module.exports = __webpack_public_path__ + "img/zxxk@2x.5e42cb31.png";